export const ApplicationTypes = [
  { id: "GENERATIVE_AI", name: "PRODUCT_TYPES.GENERATIVE_AI" },
  { id: "PREDICTIVE_AI", name: "PRODUCT_TYPES.PREDICTIVE_AI" },
  { id: "DISCRIMINATIVE_AI", name: "PRODUCT_TYPES.DISCRIMINATIVE_AI" },
  {
    id: "REINFORCEMENT_LEARNING",
    name: "PRODUCT_TYPES.REINFORCEMENT_LEARNING",
  },
  { id: "SYMBOLIC_AI", name: "PRODUCT_TYPES.SYMBOLIC_AI" },
  { id: "CAUSAL_AI", name: "PRODUCT_TYPES.CAUSAL_AI" },
  { id: "EXPLAINABLE_AI", name: "PRODUCT_TYPES.EXPLAINABLE_AI" },
];
